import { render, staticRenderFns } from "./molecule.external.3dviewer.vue?vue&type=template&id=4055c414"
import script from "./molecule.external.3dviewer.vue?vue&type=script&lang=js"
export * from "./molecule.external.3dviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports